import { Outlet } from 'react-router';
import Sidebar from '../../components/layouts/Sidebar';
import Topbar from '../../components/layouts/Topbar';
import { IndexContainer } from './Index.elements';

const Admin = () => {
  return (
    <>
      <IndexContainer>
        <Topbar />
        <main className="container">
          <div className="main-left">
            <Sidebar />
          </div>
          <div className="main-right">
            <Outlet />
          </div>
        </main>
      </IndexContainer>
    </>
  );
};

export default Admin;
